export default function IconMenuSave({ className }) {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24.5" r="24" fill="#F5F7F7" />
      <mask
        id="mask0_3517_34409"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="49"
      >
        <circle cx="24" cy="24.5" r="24" fill="#FFF19A" />
      </mask>
      <g mask="url(#mask0_3517_34409)">
        <path
          d="M42.5 31.4474V15.2588C42.5 13.7351 41.2555 12.5 39.7202 12.5C38.1849 12.5 36.3741 13.7351 36.3741 15.2588V31.4474C41.4503 31.4474 40.7159 31.4474 42.5 31.4474Z"
          fill="#5FA518"
        />
        <path
          d="M36.9403 12.5H32.1168H10.2801C8.74485 12.5 7.50031 13.7351 7.50031 15.2588V51.9737C15.9854 51.9737 35.0776 51.9737 36.9403 51.9737V15.2588C36.9403 13.7351 38.1849 12.5 39.7202 12.5H36.9403Z"
          fill="#7BCC29"
        />
        <mask
          id="mask1_3517_34409"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="7"
          y="12"
          width="33"
          height="41"
        >
          <path
            d="M36.94 12.5H32.1165H10.2798C8.74454 12.5 7.5 13.7351 7.5 15.2588V52.5H20.3303C23.2435 52.5 35.0776 52.5 36.94 52.5V15.2588C36.94 13.7351 38.1846 12.5 39.7199 12.5H36.94Z"
            fill="#7BCC29"
          />
        </mask>
        <g mask="url(#mask1_3517_34409)">
          <rect
            x="22.3494"
            y="12.5"
            width="18.0315"
            height="40"
            fill="#7BCC29"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.7821 5.16086V-2.20721L52.5454 1.48462L48.7821 5.16086ZM41.2549 5.16104L41.2548 5.16092L45.018 1.48486L41.2546 -2.20697V5.16074L37.4916 1.4848V8.85292L41.2549 5.16104ZM41.1987 27.3531V19.985L44.962 23.669L44.9618 23.6693L41.2026 27.357L44.9618 31.0447V23.6693L48.7251 27.3611L44.962 31.045L44.9619 31.0451L48.7251 34.7212L44.9619 38.413L44.962 38.4132L41.1988 42.1049L44.962 45.7888L44.9615 45.7893L41.1988 49.4728L41.1989 49.4729L37.4356 53.1571V45.7889L41.1987 49.4727V42.105L37.4353 45.7889V38.4131L41.1987 42.1049L41.1987 42.1048V34.7214L37.4356 38.413V31.0449L41.1987 34.7209L41.1987 27.361L41.1987 27.3609V27.3531ZM41.1987 27.361L37.4356 31.0449L37.4353 31.0451V23.6692L41.1987 27.361ZM44.9615 45.7893L48.7248 49.4734L44.9615 53.1575V45.7893ZM44.9618 38.4129V31.0452L41.1988 34.7211L41.1989 34.7212L41.1987 34.7213L44.9618 38.4129ZM33.6512 34.7828L33.6514 34.783V34.7827L33.6512 34.7828ZM33.6553 34.7789L37.4147 38.4669L33.6514 42.1431V34.7834L29.8885 38.4671L29.8886 38.4672L29.8884 38.4673L33.6516 42.1434L33.6513 42.1437L37.4143 45.8352L33.6511 49.527L33.6516 49.5274L29.8883 53.2114V45.8356L33.651 49.5269V42.1439L29.8883 45.8353V38.4675L26.1252 42.1434V34.7831V34.7753L26.1252 27.431L26.1135 27.4425V20.0743L29.8763 23.7578V16.3827L26.1132 20.0743V12.6906L29.8763 16.3822V9.01478L26.1135 12.6906V5.33029V5.32251V-2.04553L29.8768 1.63849L29.8765 1.63879L33.6396 5.33038L29.8767 9.01409L29.8768 9.01424L29.8766 9.0145L33.6396 12.6905L29.8764 16.3823L29.8765 16.3825L29.8764 16.3826L33.6396 20.0744L29.8766 23.7582L29.8768 23.7584L29.8765 23.7587L33.6396 27.4425L29.9002 31.1031L33.651 34.7826V27.4316L33.6401 27.4423V20.0742L37.4034 23.7582L33.6635 27.4193L37.4143 31.0911L33.6553 34.7789ZM26.1374 27.4191L29.8763 23.7589V31.0791L26.1374 27.4191ZM26.1292 34.7792L29.8763 31.1033V31.1265L29.8883 31.1148L29.8883 38.4669L26.1292 34.7792ZM26.1132 27.4425L22.3739 31.1029L26.125 34.7827L22.3617 38.4669V31.1149L22.3498 31.1265L22.3498 23.7584L26.1132 27.4425ZM22.3614 38.4672V45.8353L26.1247 42.1434L22.3614 38.4672ZM22.362 53.2111V45.8352L26.1249 49.5266V42.1434L29.8882 45.8353L26.1251 49.5269L26.1254 49.5271L22.362 53.2111ZM44.9621 38.4129V45.7888L48.7251 42.105V42.1052L48.7254 42.1049V49.4729L52.4888 45.7888L48.7255 42.1048L52.4885 38.4133L48.7251 34.7214V42.1045L44.9621 38.4129ZM52.4885 23.6692L48.7293 27.357L52.4887 31.045L48.7254 34.7213V27.3608L48.7251 27.3611V19.9852L52.4885 23.6692ZM37.4916 16.2288V23.5969L41.2546 19.9131L41.2549 19.9128L45.018 16.229L41.2546 12.545V19.9125L37.4916 16.2288ZM37.4912 16.229V8.85309L41.2545 12.5449L37.4912 16.229ZM41.2549 5.16095V12.5447L45.018 8.85314V16.2288L48.7814 12.5447L45.0182 8.85299L45.0183 8.85286L41.2549 5.16095ZM45.0183 23.5969V16.2288L48.7817 19.9129L45.0183 23.5969ZM45.0183 1.4848V8.85292L48.7817 5.16104L45.0183 1.4848ZM48.7817 5.16119V12.5448V12.5449V19.9129L52.5451 16.2288L48.7818 12.5449L52.5451 8.85302L48.7817 5.16119ZM22.3494 9.01444V1.63876L26.1128 5.33059L22.3496 9.01457L26.1128 12.6907L22.3494 16.3827V9.01469V9.01444ZM22.3494 23.7586V16.3827L26.1128 20.0745L22.3494 23.7586ZM26.1175 5.3264L29.8763 9.0137V1.63903L26.1175 5.3264ZM33.6396 20.0744V12.6908V12.6907V5.32269L33.6401 5.32312V-2.04553L37.4034 1.63849L33.6437 5.3267L37.403 9.01442L33.6397 12.6907L37.403 16.3825L33.6396 20.0744Z"
            fill="#69B51B"
          />
          <path
            d="M31.5 25H22.4999V16C24.8869 16 27.1761 16.9482 28.8639 18.636C30.5517 20.3239 31.5 22.6131 31.5 25Z"
            fill="#F5A400"
          />
          <path
            d="M31.5 25.0001C31.501 26.8928 30.9024 28.7372 29.79 30.2685L27.7684 32.2901C26.0367 33.5454 23.914 34.1417 21.7819 33.9717C19.6498 33.8016 17.6484 32.8764 16.1376 31.3624L22.4999 25.0001H31.5Z"
            fill="#FFBB33"
          />
          <path
            d="M22.5 25.0001L16.1377 31.3624C14.8018 30.0264 13.9199 28.304 13.6167 26.4392C13.3136 24.5743 13.6045 22.6613 14.4484 20.9709L22.5 25.0001Z"
            fill="#FFE14D"
          />
          <path
            d="M22.5 16V25L14.4484 20.9708C15.1966 19.4764 16.3462 18.2198 17.7682 17.3419C19.1903 16.4639 20.8287 15.9993 22.5 16Z"
            fill="#FFF5C4"
          />
        </g>
        <rect
          x="16.9348"
          y="36.5"
          width="10.3551"
          height="1.92685"
          rx="0.963427"
          fill="#ACF364"
        />
        <rect x="15" y="40.5" width="14" height="2" rx="1" fill="#ACF364" />
      </g>
    </svg>
  );
}
